import React from 'react';
import { useParams } from 'react-router-dom';
import Resume from '../Candidate/Resume/Jobmyresume';

const CandidateProfile = () => {

    const { id } = useParams();

    return (
        <>
            <Resume joc={true} id={id} />
        </>
    );
};

export default CandidateProfile;